import { DELETE_OUR_WORK_ERROR, DELETE_OUR_WORK_START, DELETE_OUR_WORK_SUCCESS } from '../../types';

export default function delete_our_work(state, action) {
  switch (action.type) {
    case DELETE_OUR_WORK_START:
      return { ...state };
    case DELETE_OUR_WORK_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_OUR_WORK_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}